var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M816.078 735.884H208.121c-61.81 0-112.096-50.286-112.096-112.096V255.879c0-52.987 43.108-96.096 96.096-96.096h623.958c61.81 0 112.096 50.286 112.096 112.096v351.909c-0.001 61.81-50.287 112.096-112.097 112.096z m-623.957-512.1c-17.698 0-32.096 14.398-32.096 32.096v367.909c0 26.521 21.576 48.096 48.096 48.096h607.958c26.521 0 48.096-21.575 48.096-48.096v-351.91c0-26.52-21.575-48.096-48.096-48.096H192.121zM704.137 863.721H320.062c-17.673 0-32-14.327-32-32s14.327-32 32-32h384.075c17.673 0 32 14.327 32 32s-14.327 32-32 32z",
    fill: "#a3bde3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.715 422.874l48.678-41.548 136.525 159.952-48.679 41.548z",
    fill: "#a3bde3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.37 532.266l258.353-211.969 40.595 49.479-258.353 211.969z",
    fill: "#a3bde3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.f36aa4e4ee54a24478b6b2d25844439a.svg";
export { ForwardRef as ReactComponent };